export default "__VITE_ASSET__ewHREY5m__"